(function () {
  var SECTION_SELECTOR = '.oddit-section-blog-grid';

  function initSection(section) {
    var track = section.querySelector('.oddit-section-blog-grid__cards');
    var dots = section.querySelectorAll('.oddit-section-blog-grid__dot');
    if (!track || dots.length === 0) return;

    var cards = track.querySelectorAll('.oddit-section-blog-grid__card');
    if (cards.length === 0) return;

    function getActiveIndex() {
      var scrollLeft = track.scrollLeft;
      var closestIndex = 0;
      var closestDistance = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var offset = cards[i].offsetLeft;
        var distance = Math.abs(offset - scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      }
      return Math.min(closestIndex, dots.length - 1);
    }

    function updateDots() {
      var activeIndex = getActiveIndex();
      for (var i = 0; i < dots.length; i++) {
        if (i === activeIndex) {
          dots[i].classList.add('oddit-section-blog-grid__dot--active');
          dots[i].setAttribute('aria-selected', 'true');
        } else {
          dots[i].classList.remove('oddit-section-blog-grid__dot--active');
          dots[i].setAttribute('aria-selected', 'false');
        }
      }
    }

    function scrollToIndex(index) {
      if (index < 0 || index >= cards.length) return;
      var target = cards[index];
      if (!target) return;
      track.scrollTo({
        left: target.offsetLeft,
        behavior: 'smooth'
      });
    }

    // Dot clicks
    for (var i = 0; i < dots.length; i++) {
      (function (idx) {
        dots[idx].addEventListener('click', function () {
          scrollToIndex(idx);
        });
      })(i);
    }

    // Update dots on scroll (throttled via rAF)
    var rafId = null;
    track.addEventListener(
      'scroll',
      function () {
        if (rafId) return;
        rafId = requestAnimationFrame(function () {
          updateDots();
          rafId = null;
        });
      },
      { passive: true }
    );

    // Initial state
    updateDots();
  }

  function init() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();